// extracted by mini-css-extract-plugin
export default {"rowBlock":"_3c8Om___antdOverrides-module__rowBlock"};